import { render, staticRenderFns } from "./holiday2.vue?vue&type=template&id=f1258d68&"
import script from "./holiday2.vue?vue&type=script&lang=js&"
export * from "./holiday2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports